import { EVENT_TYPES, RUDDERSTACK_EVENTS } from '../constants';
import { trackRudderStackEvent } from '../trackRudderStackEvent';

type EventArguments = Record<string, any>;
type EventType = keyof typeof RUDDERSTACK_EVENTS;

const createTrackRGEvent = (eventType: EventType) => {
    return (eventLabel: string, args: EventArguments = {}) => {
        const eventName = RUDDERSTACK_EVENTS[eventType](eventLabel);
        trackRudderStackEvent(eventName, {
            ...args,
            eventType: EVENT_TYPES.RG,
        });
    };
};

/**
 * @deprecated - to be removed
 * confirmed with Alex, Rudderstack is not used for analytics, so we can consolidate analytics
 * and route everything through BetrAnalytics -> Firebase etc.
 */
export const TrackRGEvent = {
    accountScreen: createTrackRGEvent('click'),
    depositLimitsScreen: createTrackRGEvent('click'),
    depositLimitAddScreen: createTrackRGEvent('submit'),
    depositLimitEditConfirmation: createTrackRGEvent('submit'),
    gamingLimitScreen: createTrackRGEvent('click'),
    maxSingleEntryLimitAddScreen: createTrackRGEvent('submit'),
    maxSingleEntryLimitsScreen: createTrackRGEvent('click'),
    playLimitsScreen: createTrackRGEvent('click'),
    playLimitAddScreen: createTrackRGEvent('submit'),
    realityCheckScreen: createTrackRGEvent('click'),
    selfExcludeConfirmation: createTrackRGEvent('submit'),
    timeoutScreen: createTrackRGEvent('click'),
    timeoutAddScreen: createTrackRGEvent('click'),
};
